import { AppUpdate } from '@/types/updates';

export const update_2025_11: AppUpdate = {
  id: 'studio-ux-2025-11',
  slug: 'studio-ux-overhaul-control-islands',
  title: 'Interface 2.0: The Rise of Control Islands',
  description: 'In late January, we reimagined how you interact with the studio. We introduced "Control Islands" and a professional bento-grid layout for total creative immersion.',
  date: 'January 28, 2026',
  timestamp: 1769558400,
  category: 'IMPROVEMENT',
  version: '0.6.0',
  readTime: '5 min read',
  author: {
    name: 'FCG Dev',
    role: 'Lead Architect'
  },
  content: [
    {
      type: 'heading',
      content: 'A Professional Cockpit for Physics'
    },
    {
      type: 'text',
      content: 'As we added more features to Fun Circle Games, the biggest challenge wasn\'t the physics—it was the interface. Our early menus were cluttered and distracting. We needed a design language that felt as "clean" and "satisfying" as the simulations themselves.'
    },
    {
      type: 'heading',
      content: 'Introducing Control Islands'
    },
    {
      type: 'text',
      content: 'We moved away from traditional sidebars to "Control Islands"—floating, semi-transparent panels that dock to the edges of the screen. This allows the simulation to take center stage while keeping power-user tools just a glance away.'
    },
    {
      type: 'list',
      content: [
        'Bento-Grid Logic: We organized settings into logical "Bento Boxes," making it easy to find Physics, Visuals, and Audio settings individually.',
        'Visual Feedback HUD: The new Heads-Up Display (HUD) provides real-time data on collisions, FPS, and current melody notes without blocking the view.',
        'Collapsible Sections: Every control group can now be minimized to clear the workspace for recording.',
        'Smart Inputs: Precise slider and numeric inputs were added to allow for frame-perfect simulation tuning.'
      ]
    },
    {
      type: 'heading',
      content: 'The "Pristine Light" Aesthetic'
    },
    {
      type: 'text',
      content: 'This update also standardized our visual language. We committed to the "Pristine Light" theme: white backgrounds, subtle Zinc-200 borders, and neon accents. This creates a technical, professional vibe that makes the colorful physics events "pop" off the screen.'
    },
    {
      type: 'highlight',
      content: '"A great interface should disappear when you don\'t need it and feel like a professional instrument when you do."'
    },
    {
      type: 'heading',
      content: 'Workflow Enhancements'
    },
    {
      type: 'text',
      content: 'We also improved the "Studio Workspace." Preset loading is now instant, and we added the foundation for the "Mode Selector," allowing you to switch between Rhythmic, Escape, and Trail modes without needing to restart the application.'
    }
  ]
};
